import PusherJs from "pusher-js";

export const pusherClient = new PusherJs(import.meta.env.VITE_SOCKET_APP_KEY, {
  wsHost: import.meta.env.VITE_SOCKET_SERVER_URL,
  wsPort: 80,
  wssPort: 443,
  forceTLS: true,
  cluster: "",
  disableStats: true,
  enabledTransports: ["ws", "wss"],
});
